(function fileDetailControllerDefinition() {
    'use strict';

    angular.module('File')
        .controller('FileDocumentDetailController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', 'errorsExtend', 'fileService', 'storageService', 'documentService', 'myDocument',
            function fileDetailController($scope, config, $state, $translate, $stateParams, errors, fileService, storageService, documentService, myDocument) {

                function detectIE() {
                    var ua = window.navigator.userAgent;

                    var msie = ua.indexOf('MSIE ');
                    if (msie > 0) {
                        // IE 10 or older => return version number
                        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
                    }

                    var trident = ua.indexOf('Trident/');
                    if (trident > 0) {
                        // IE 11 => return version number
                        var rv = ua.indexOf('rv:');
                        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
                    }

                    return false;
                };

                $scope.IsIe = detectIE();
                $scope.hasFilesSigned = false;
                $scope.hasFilesNotConverted = false;

                $scope.docu = {
                    documentTypes: [],
                    accordionIsOpen: false,
                    filesAccordionIsOpen: false,
                    hasMetadata: false
                };

                $scope.cancel = function () {
                    $state.goBack();
                };

                $scope.initDocumentFind = function () {
                    if ($scope.urlFind) {
                        $state.go($scope.urlFind);
                    }
                };

                $scope.fileNames = [];

                $scope.load = function () {
                    $scope.urlFind = storageService.getStateBackFind();
                    $scope.hasBack = $state.hasPrevious();

                    $scope.viewPdf(false);
                }

                $scope.viewAll = function () {
                    $scope.content = undefined;
                    $scope.file = undefined;
                    return $scope.viewPdf(true);
                }

                $scope.viewPdf = function (viewAll) {
                    return fileService.getDocumentVersion($stateParams.id, $stateParams.version, viewAll, $stateParams.file).then(function (result) {
                        if (result.base64File !== '') {
                            $scope.content = 'data:application/pdf;base64,' + result.base64File;
                            $scope.file = result;
                            $scope.hasFilesNotConverted = $scope.file.filesNotConverted.length > 0;

                            if ($scope.file.fileNames != null) {
                                $scope.file.fileNames.forEach(function (name) {
                                    var fileData = {};
                                    fileData.name = name.key;
                                    fileData.isSigned = name.value;
                                    if (fileData.isSigned) {
                                        $scope.hasFilesSigned = true;
                                    }
                                    if (result.filesNotConverted.indexOf(fileData.name) != -1) {
                                        fileData.IsNotConverted = true;
                                    }
                                    $scope.fileNames.push(fileData);
                                })
                            }
                            var tempVersion = true;

                            if ($scope.urlFind === 'document-advanced-find') {
                                tempVersion = false;
                            }

                            $translate(['FileDocumentDetail','FileDetail']).then(function (translated) {
                                if ($stateParams.file) {
                                    $scope.title = translated.FileDetail + $scope.file.documentVersionName;
                                } else {
                                    $scope.title = translated.FileDocumentDetail + $scope.file.documentVersionName;
                                }
                            });
                        }
                        else {
                            if (result.filesNotConverted && result.filesNotConverted.length > 0) {
                                errors.showWarning('AllFilesNotConverted');
                            }
                            else {
                                errors.showWarning('The document has no files');
                            }
                            $scope.cancel();
                        }
                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError(error);
                        }
                        $scope.cancel();
                    });
                }

                $scope.metadataCount = function (document) {
                    if (document.documentTypes && document.documentTypes.length) {
                        return document.documentTypes.reduce(function (valorPrevio, valorActual, indice, array) { return valorPrevio + valorActual.metadatas.length; }, 0);
                    }
                    return 0;
                };

                $scope.toggleAccordion = function () {
                    if ($scope.docu.accordionIsOpen) {
                        $scope.fillDocMetadata();
                    }
                };

                $scope.fillDocMetadata = function () {

                    if ($scope.docu.documentTypes.length === 0) {

                        return $scope.getMetadata(false).then(function (result) {

                        }, function (error) {
                            errors.showError(error);
                            $scope.cancel();
                        });
                    }
                }

                $scope.getMetadata = function () {
                    return documentService.getById($stateParams.id, myDocument).then(function (result) {
                        $scope.docu.documentTypes = result.documentTypes;

                        $scope.docu.documentTypes.forEach(function (docType) {
                            docType.metadatas.sort(function (a, b) {
                                return a.position - b.position;
                            });
                        });

                        $scope.docu.hasMetadata = ($scope.metadataCount($scope.docu) !== 0);
                    });
                };

                $scope.load();
            }
        ]);
})();